import React, { useState, useEffect, useMemo } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import DynamicForm from './DynamicForm';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { saveCicacStep, getCicacStep, sendToAdel } from "../../services/cicacWizardService";
import { useParams } from "react-router-dom";
import { properties } from '../../utils/Properties_es';

export default function CicacForm({ onValidate, data, updateData }) {
  const { id: idTransaction } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    updateData({
      [name]: value,
      ...(name === 'permisoCicac' && value === 'SI'
        ? { razonNoAutorizacion: '' }
        : {}),
    });
    setError('');
  };
const handleContinue = async () => {
// Validaciones
  if (data.permisoCicac === '') {
    setError(properties.cicac_error_select);
    return false;
  }

  if (data.permisoCicac === 'NO' && !data.razonNoAutorizacion) {
    setError(properties.cicac_error_reason);
    return false;
  }

  setSending(true);
  setError('');

  try {
    //Guardar CICAC
    await saveCicacStep(idTransaction, data);
    //Llamar Adel
    const adelResult = await sendToAdel(idTransaction);
    //Si Adel devolvió error funcional
    if (!adelResult.success) {
      setError(adelResult.message);
      setSending(false);
      return false;
    }
    //Todo salió bien
    setSending(false);
    return true;

  } catch (err) {
    console.error(err);
    setError(properties.cicac_error_send);
    setSending(false);
    return false;
  }
};
  useEffect(() => {
    async function loadCicac() {
      try {
        const cicac = await getCicacStep(idTransaction);
        if (!cicac) return;

        updateData({
          permisoCicac: cicac.allowUploadInfo ? "SI" : "NO",
          razonNoAutorizacion: cicac.reason || "",
        });
      } catch (e) {
        console.log("No hay CICAC previo");
      }
    }

    loadCicac();
  }, []);


  const isFormValid = useMemo(() => {
    if (data.permisoCicac === 'SI') {
      return true;
    }
    if (data.permisoCicac === 'NO' && data.razonNoAutorizacion !== '') {
      return true;
    }
    return false;
  }, [data]);

  // Configuración de campos
  const fieldConfig = [
    [
      {
        key: 'permisoCicac',
        label: (
          <strong>
            {properties.cicac_question}
          </strong>
        ),
        type: 'radio',
        className: 'radio-inline',
        options: [
          { key: properties.general_yes, value: 'SI' },
          { key: properties.general_no, value: 'NO' },
        ],
      },
    ],
  ];

  if (data.permisoCicac === 'NO') {
    fieldConfig.push([
      {
        key: 'razonNoAutorizacion',
        label: (
          <strong>
            {properties.cicac_reason_title}
          </strong>
        ),
        type: 'radio',
        options: [
          {
            key: properties.cicac_reason_1,
            value: '3',
          },
          {
            key: properties.cicac_reason_2,
            value: '2',
          },
          {
            key: properties.cicac_reason_3,
            value: '4',
          },
          {
            key: properties.cicac_reason_4,
            value: '5',
          },
          {
            key: properties.cicac_reason_5,
            value: '6',
          },
          {
            key: properties.cicac_reason_6,
            value: '8',
          },
          {
            key: properties.cicac_reason_7,
            value: '1',
          },
        ],
      },
    ]);
  }

  const onClickContinuar = async (e) => {
    e.preventDefault();
    setError('');
    const ok = await handleContinue();
    if (ok) {
      navigate(`/forms/${idTransaction}/success`);

    }
  };

  return (
    <Container className="py-5 cicac-form">
      <style>{`
        /* ====== ESTILOS GENERALES ====== */
        .cicac-form .form-check {
          display: block !important;
          width: 100% !important;
          text-align: left !important;
          margin-bottom: .5rem;
        }

        .cicac-form .form-check-input {
          margin-left: 0 !important;
          margin-right: .5rem !important;
        }

        .cicac-form .form-check-label {
          display: inline;
        }

        .cicac-form .validation-error {
          color: #c72828;
          margin-top: .5rem;
          font-size: 0.9rem;
        }

        /* ====== CASO ESPECIAL: Sí y No en la misma línea ====== */
        .cicac-form .radio-inline .form-check {
          display: inline-flex !important;
          align-items: center;
          margin-right: 1.5rem;
          width: auto !important;
        }

        .cicac-form .radio-inline .form-check-input {
          margin-top: 0;
        }
      `}</style>

      <Row>
        <Col md={{ span: 10, offset: 1 }}>
          <h5 className="mb-3">
            <strong>{properties.cicac_title}</strong>
          </h5>
          <p className="text-secondary">
            {properties.cicac_description_1}{' '}
            <strong>{properties.cicac_description_sugef}</strong>{' '}
            {properties.cicac_description_2}{' '}
            <strong>{properties.cicac_description_kyc}</strong>
            {properties.cicac_description_3}
          </p>

          <Form className="mt-4 text-start">
            <DynamicForm
              fieldConfig={fieldConfig}
              formData={data}
              handleChange={handleChange}
              notClass={true}
            />
            {error && <div className="validation-error">{error}</div>}
          </Form>

          <Row className="mt-4">
            <Col className="d-flex justify-content-end gap-2">
              <Button variant="outline-primary" className="px-5 py-2 shadow rounded-0" as={Link} to={`/forms/${idTransaction}/costs`}>
                {properties.btn_back}
              </Button>
              <Button
                variant="primary"
                size="sm"
                className="px-5 py-2 shadow rounded-0"
                disabled={!isFormValid || sending}
                onClick={onClickContinuar}
              >
                {sending ? properties.btn_sending : properties.btn_continue}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}